import { Box, Container, Grid, styled, useTheme } from "@mui/material";
import {
  ContactPhoneIcon,
  EmailIcon,
  InstagramIcon,
  TelegramIcon,
  WhatsAppIcon,
} from "assets/Icon";

function ContentWrapper() {
  const theme = useTheme();

  return (
    <Container>
      <Grid Container spacing={2}>
        <Grid item xs={12}>
          <BoxItem>
            <TelegramIcon color={theme.palette.info.light} />
            <a href="https://t.me/SanaCash">https://t.me/SanaCash</a>
          </BoxItem>
        </Grid>

        <Grid item xs={12}>
          <BoxItem>
            <WhatsAppIcon color={theme.palette.info.light} />
            <a href="https://wa.me/+989381091635">+98 9381091635</a>
          </BoxItem>
        </Grid>

        <Grid item xs={12}>
          <BoxItem>
            <EmailIcon color={theme.palette.info.light} />
            <a href="mailto: info@sanacash.net">Info@sanacash.net</a>
          </BoxItem>
        </Grid>

        <Grid item xs={12}>
          <BoxItem>
            <ContactPhoneIcon color={theme.palette.info.light} />
            <a href="tel: +982122231592">+98 21 22231592</a>
          </BoxItem>
        </Grid>

        <Grid item xs={12}>
          <BoxItem>
            <ContactPhoneIcon color={theme.palette.info.light} />
            <a href="tel: +982122202080">+98 21 22202080</a>
          </BoxItem>
        </Grid>
      </Grid>
    </Container>
  );
}

const BoxItem = styled(Box)(({ theme }) => ({
  margin: `0 auto ${theme.spacing(2)} auto`,
  display: "flex",
  alignItems: "center",
  maxWidth: "210px",
  a: {
    color: theme.palette.secondary.main,
    paddingLeft: theme.spacing(1),
    textDecoration: "none",
    fontSize: "16px",
  },
}));
export default ContentWrapper;
